import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map, size } from 'lodash-es'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { TASK_REOPEN_REASONS } from '../../tasks/constants'
import { DEFAULT_PAGE } from '../constants'

const TaskReopenReasonFilter = ({ disabled }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { reopenReasons } = getQueryParams(search)

  const handleChange = useCallback(
    reopenReasons =>
      history.push(
        createUrl(pathname, search, {
          reopenReasons,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  const getMaxTagPlaceholder = useCallback(
    omittedValues => `+ ${size(omittedValues)} more`,
    [],
  )

  return (
    <Form.Item label="Reopen reason">
      <Select
        style={{ width: '100%' }}
        value={reopenReasons}
        onChange={handleChange}
        disabled={disabled}
        dropdownStyle={{ minWidth: 'fit-content' }}
        allowClear
        mode="multiple"
        maxTagCount={1}
        maxTagPlaceholder={getMaxTagPlaceholder}
      >
        {map(TASK_REOPEN_REASONS, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

TaskReopenReasonFilter.propTypes = {
  disabled: PropTypes.bool,
}

TaskReopenReasonFilter.defaultProps = {
  disabled: false,
}

export default TaskReopenReasonFilter
